export function readErrorDescription(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'description' in error && typeof error.description === 'string') {
    const description = error.description.trim()
    if (description) return description
  }

  if (error instanceof Error && error.message) return error.message
  if (typeof error === 'string' && error.trim()) return error

  return fallback
}
